import React from 'react';
import Grid from "@material-ui/core/Grid";
import TitleHead from '../../assets/title_head.svg';


const Head = (props) => {
    const {isVisible, title, selectItem} = props;
    if (isVisible) {
        if (selectItem !== undefined) {
            selectItem('SURVEY_' + props.step);
        }
    }

    return (
        <Grid container direction="row" alignItems='center'>
            <div className="title-head">
                {/*<img src={TitleHead}/>*/}
                <span><div dangerouslySetInnerHTML={ {__html: title} } /></span>
            </div>
        </Grid>
    )
};

export default Head;
